module.exports = __webpack_public_path__ + "static/media/logo-login.500ef178.png";